/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Entra_Step4Inputs */



/**
* | output |
* | --- |
* | "Enter the Tenant URL:" |
*
* @param {Scim_Setup_Entra_Step4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_entra_step4 = /** @type {((inputs?: Scim_Setup_Entra_Step4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Entra_Step4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie die Mandanten-URL ein:")
	return /** @type {LocalizedString} */ ("Enter the Tenant URL:")
});